import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { getCategoryName } from "@/utils/comic";

interface ComicCardProps {
  comic: Comic;
  showLatest?: boolean;
}

export default function ComicCard({ comic, showLatest = true }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} 漫画封面`}
          title={`${comic.title} - 蛙漫在线漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
        />
        <span
          className={`absolute top-2 left-2 px-2 py-0.5 rounded-md text-[11px] font-label font-bold ${
            comic.status === "连载中"
              ? "bg-primary-500 text-background-50"
              : "bg-secondary-500 text-background-50"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md text-[11px] font-label text-background-50 bg-foreground-950/60">
          {comic.rating.toFixed(1)} 分
        </span>
      </div>
      <div className="p-3 flex flex-col gap-1.5">
        <h3 className="text-sm font-label font-bold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-600 line-clamp-1">
          {comic.authorName} · {comic.categoryIds.map(getCategoryName).slice(0, 2).join(" / ")}
        </p>
        {showLatest && (
          <p className="text-xs text-primary-700 line-clamp-1 flex items-center gap-1">
            <i className="ri-refresh-line"></i>
            {comic.latestChapter}
          </p>
        )}
      </div>
    </Link>
  );
}